"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ionadi": {
    "ba1fed12": [{
      "hkey": "1d5c79ac",
      "slug": "baraccone",
      "name": "Baraccone",
      "primary": true,
      "skipSearch": false
    }],
    "baracconi": [{
      "hkey": "1d5c79ac",
      "slug": "baraccone",
      "name": "Baraccone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a0073126": [{
      "hkey": "a21bae76",
      "slug": "ionadi",
      "name": "Ionadi",
      "primary": true,
      "skipSearch": false
    }],
    "case-sparse": [{
      "hkey": "a21bae76",
      "slug": "ionadi",
      "name": "Ionadi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5c326379": [{
      "hkey": "a21bae76",
      "slug": "ionadi",
      "name": "Ionadi",
      "primary": true,
      "skipSearch": false
    }],
    "nao": [{
      "hkey": "a21bae76",
      "slug": "ionadi",
      "name": "Ionadi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b022e689": [{
      "hkey": "60df18bf",
      "slug": "vena",
      "name": "Vena",
      "primary": true,
      "skipSearch": false
    }],
    "vena-di-jonadi": [{
      "hkey": "60df18bf",
      "slug": "vena",
      "name": "Vena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;